import React from 'react';
import PropTypes from 'prop-types';
import { Factory } from './node-factory';

const nodeShape = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

nodeShape.children = PropTypes.arrayOf(PropTypes.shape(nodeShape));

export const NodeRender = ({
  rootId,
  node,
  dynamicComponentRender,
}) => {
  const {
    children: childNodes,
  } = node;

  return (
    <Factory
      key={node.id}
      node={node}
      rootId={rootId}
      dynamicComponentRender={dynamicComponentRender}
    >
      {
        childNodes && childNodes.map(childNode => NodeRender({
          node: { ...childNode, totalNodesWithSameLevel: childNodes.length },
          dynamicComponentRender,
          rootId,
        }))
      }
    </Factory>
  );
};

NodeRender.propTypes = {
  node: PropTypes.shape({
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.shape(nodeShape)),
  }).isRequired,
  rootId: PropTypes.string.isRequired,
  dynamicComponentRender: PropTypes.func.isRequired,
};
